import React from 'react';
import moment from 'moment-timezone';
import { calculateDateFromDayIndex, getTime } from '../../utils';
import { ROW_HEIGHT, ROWS, SPAN_ROTATION_PADDING } from '../../const';
export var EmptyCell = function (_a) {
    var date = _a.date, dayIndex = _a.dayIndex, span = _a.span, timezone = _a.timezone, disabled = _a.disabled, onClick = _a.onClick, _b = _a.permissions, permissions = _b === void 0 ? { update_past_rotations: false, reset_rotations: false } : _b;
    var clickedDateTime = calculateDateFromDayIndex(dayIndex, date, timezone);
    var hasValidTimezone = Boolean(timezone && moment.tz.zone(timezone));
    var now = hasValidTimezone ? moment().tz(timezone) : moment();
    // If user has permission to update past rotations, all cells are clickable. Otherwise, only future cells are clickable.
    var isClickable = (permissions.update_past_rotations || moment(clickedDateTime).isAfter(now)) && !disabled;
    return ((React.createElement("div", { className: isClickable ? 'empty-cell empty-cell-clickable' : 'empty-cell', style: {
            gridRow: "span ".concat(span),
            height: "".concat(ROW_HEIGHT * ROWS - 1, "px"),
        }, onClick: function () { return isClickable && onClick(dayIndex, null); }, "data-testid": isClickable ? "tech-rotation-empty-cell-".concat(dayIndex) : undefined }, "+")));
};
var TechniciansInfo = function (_a) {
    var _b, _c, _d;
    var rotation = _a.rotation, contacts = _a.contacts;
    return (React.createElement("div", { className: "technician-info" },
        React.createElement("div", null, "P:"),
        React.createElement("div", null, (_b = contacts.find(function (c) { return c.id === rotation.primaryTechnician; })) === null || _b === void 0 ? void 0 : _b.name),
        React.createElement("div", null, "B:"),
        React.createElement("div", null, (_c = contacts.find(function (c) { return c.id === rotation.backupTechnician; })) === null || _c === void 0 ? void 0 : _c.name),
        React.createElement("div", null, "F:"),
        React.createElement("div", null, (_d = contacts.find(function (c) { return c.id === rotation.finalTechnician; })) === null || _d === void 0 ? void 0 : _d.name)));
};
var Rotation = function (_a) {
    var rotation = _a.rotation, contacts = _a.contacts, disabled = _a.disabled, readOnly = _a.readOnly, onClick = _a.onClick;
    if (!rotation)
        return null;
    if (!rotation.show)
        return null; // Skip if show is false
    var rotationLength = rotation.to - rotation.from;
    var from = getTime(rotation.from);
    var to = getTime(rotation.to);
    var isStoreHours = rotation.serviceStatus === 'store_hours';
    var isOverride = rotation.serviceStatus === 'override';
    // When disabled (loading/saving), nothing is clickable
    // When readOnly (rotation list set), only overrides are clickable
    // Otherwise, everything except store_hours is clickable
    var isClickable = !disabled && (isOverride || (!readOnly && !isStoreHours));
    var variants = {
        store_hours: 'rotation--store-hours',
        available: 'rotation--available',
        no_service: 'rotation--no-service',
        no_service_holiday: 'rotation--no-service',
        default: 'rotation--default',
        override: 'rotation--override',
        override_future: 'rotation--override',
        override_holiday: 'rotation--override-holiday',
        override_no_service: 'rotation--override-no-service',
    };
    var labels = {
        store_hours: 'Store Hours',
        available: 'Available',
        default: 'Available',
        override: 'Override',
        override_future: 'Override',
        no_service: 'No Service',
        no_service_holiday: 'No Service',
        override_no_service: 'No Service',
        Unknown: 'Unknown',
    };
    if (rotationLength > 2) {
        labels.available = React.createElement(TechniciansInfo, { rotation: rotation, contacts: contacts });
        labels.default = React.createElement(TechniciansInfo, { rotation: rotation, contacts: contacts });
        labels.override = React.createElement(TechniciansInfo, { rotation: rotation, contacts: contacts });
        labels.override_future = React.createElement(TechniciansInfo, { rotation: rotation, contacts: contacts });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "rotation-container", style: {
                height: "".concat((rotationLength * ROWS * ROW_HEIGHT) - SPAN_ROTATION_PADDING, "px"),
                top: "".concat(1 + ((rotation.from * ROWS) % (24 * ROWS)) * ROW_HEIGHT, "px"),
                position: 'absolute',
                left: 0,
                width: rotation.serviceStatus === 'override' ? '95%' : '100%',
                cursor: isClickable ? 'pointer' : 'default',
            }, onClick: function () { return isClickable && onClick(rotation.from, rotation.id); }, "data-testid": "tech-rotation-slot-".concat(rotation.id) },
            React.createElement("div", { className: "rotation ".concat(variants["".concat(rotation.serviceStatus)]), "data-testid": "tech-rotation-slot-".concat(rotation.serviceStatus) },
                rotationLength > 3 && (React.createElement("div", { style: {
                        fontSize: '10px',
                        paddingTop: '10px',
                        color: '#4b5563',
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'space-between',
                    } },
                    React.createElement("span", null, "".concat(from, " - ").concat(to)))),
                React.createElement("div", { style: {
                        flex: 1, alignItems: 'center', display: 'flex', justifyContent: 'center',
                    } }, labels[rotation.serviceStatus])))));
};
export { Rotation };
//# sourceMappingURL=Rotation.js.map